import { enumXMLType } from "../constants";
import { XML_FillRectPPT } from "./XML_FillRectPPT";
import { XML_FillRectPDF } from "./XML_FillRectPDF";

export function XML_FillRect(x, y, width, height, fillColor, fillColor2, drawElement, layer) {
  var docType = drawElement.GetDocType();

  if (docType == enumXMLType.PDF)
    XML_FillRectPDF(x, y, width, height, fillColor, fillColor2, drawElement, layer);
  else XML_FillRectPPT(x, y, width, height, fillColor, fillColor2, drawElement, layer);
}
